import React from 'react'
import "./../element.css";
function AboutUs() {
    return (
        <div className="about-us">
    <h1>About Us</h1>
    <p>Welcome to Wakin Portal, your dedicated platform for discovering real-time job opportunities through walk-in interviews. Built with a vision to make job hunting and recruitment simpler and more transparent, Wakin Portal connects job seekers and companies across all industries for immediate, genuine connections.</p>
  
    <h2>Our Mission</h2>
    <p>Our mission is to empower job seekers and employers by offering a platform that facilitates direct interaction through walk-ins, allowing for quicker evaluations and better hiring outcomes. We believe in creating valuable, accessible opportunities that benefit both job seekers and companies alike.</p>
  
    <h2>Our Current MVP</h2>
    <p>At Wakin Portal, you’re currently experiencing our Minimum Viable Product (MVP), which includes essential features to help you discover and participate in walk-in events tailored to your skills and interests. This MVP is a first step toward realizing our broader vision, with real-time job data, company profiles, and notifications to make job discovery more efficient and effective.</p>
  
    <h2>What’s Coming Next</h2>
    <p>We’re excited to announce that a more comprehensive dashboard is on the way! This upcoming feature will empower companies to manage their walk-in events, access applicant data, and gain valuable insights through attendance analytics. Job seekers can also look forward to an enhanced experience with more personalized search tools and additional filtering options.</p>
  
    <h2>Join Us on the Journey</h2>
    <p>Whether you're a job seeker aiming to connect with the right opportunity or a company looking to engage top talent, Wakin Portal is here to support your journey. Stay tuned as we grow and enhance our platform with more robust tools and features designed for success.</p>
  </div>
  
    )
}

export default AboutUs
